import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-santamonica-bubbles.jpg`;
const ALT = "Lara sitting cross-legged against a sun-worn white wall in a 'Choose Joy' t-shirt, blowing bubbles.";

export function EverydayJoy() {
  return (
    <section data-testid="about-everyday-joy" className="relative overflow-hidden bg-[#EFF5F4]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-[20px]">
        {/* Desktop image half-band, right side */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[50%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="everyday-joy-image"
            bg="#EFF5F4"
            objectPosition="50% 24%"
            featherLeft={40}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[3/4] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="everyday-joy-image-mobile"
            bg="#EFF5F4"
            objectPosition="50% 25%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean left */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center lg:min-h-[min(75vh,720px)]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[480px]">
              <p
                data-testid="everyday-joy-header"
                className="font-display text-2xl md:text-3xl text-[#1C1917] leading-snug mb-5"
              >
                Joy has never asked me to choose between purpose and play.
              </p>
              <div
                data-testid="everyday-joy-body"
                className="space-y-3 text-lg md:text-xl leading-relaxed text-[#57534E]"
              >
                <p>I care deeply about meaningful work.</p>
                <p>
                  I also stop for puppies, adore babies, celebrate tiny
                  miracles, get goosies and frequently snort instead of laugh.
                </p>
                <p>I don&rsquo;t think those things compete.</p>
                <p>I think they make each other possible.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
